import React from 'react';

import { AccountDisplayProps } from '../AccountPanel';
import { ChartRepository } from './ChartRepository';

export const SettingChartRepository: React.FC<AccountDisplayProps> = ({
	popDisplayState,
}) => {
	return <ChartRepository onSave={popDisplayState} />;
};
